import React, { memo } from 'react';
import RouterLink from 'components/RouterLink';

interface PassthroughLinkProps {
  href: string;
  isPublic: boolean;
  children: React.ReactNode;
}

const PassthroughLink = memo(({ href, isPublic, children }: PassthroughLinkProps) =>
  isPublic ? <>{children}</> : <RouterLink href={href}>{children as React.ReactElement}</RouterLink>
);
PassthroughLink.displayName = 'PassthroughLink';

export default PassthroughLink;
